module.exports = __webpack_public_path__ + "static/media/lahore-south-dark.38fe7544.svg";